<template>
	<div v-if="isload" class="inplan">
		<el-form>
			<el-row>
				<maininfo :ref="'maininfo_'+l_id" :item="item" :l_id="l_id"></maininfo>
			</el-row>
		</el-form>
		<el-row style="margin-bottom:45px;margin-top:-10px;">
			<el-col :span="24">
				<gridlist :ref="'gridlistexpand_'+l_id" :item="item" :l_id="l_id" :rowkey="rowkey"></gridlist>
			</el-col>
		</el-row>
		<el-row v-if="!btndisabled&&isdetail==0" class="footerhandler">
			<el-col :span="4" style="text-align: right;">
				<span style="color:transparent">1</span>
			</el-col>
			<el-col :span="4" class="submitBtn"><div @click="saveorder">{{$lang.label.public.savebtn}}</div></el-col>
			<el-col :span="4" class="submitBtn_cancel"><div @click="cancel">{{$lang.label.public.cancel}}</div></el-col>
		</el-row>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
import maininfo from '@/components/tools/maininfo.vue';
import gridlist from '@/components/tools/gridlist_expand.vue';
export default {
	components: {
		maininfo,
		gridlist
	},
	props: {
		urlparam: {
			type: Object,
			default:function(){
				return {
					
				};
			}
		},
		item:{
			type: Object,
			default:function(){
				return {
					
				};
			}
		}
	},
	data() {
		return {
			pageparam: {},
			curpkval: '',
			iscopy: 0,
			type: '',
			orderinfo:'',
			l_id:'',
			isedit:'',
			btndisabled:false,
			isload:false,
			infolang:{},
			windowHeight: window.innerHeight - 120,
			t_id:'',
			pagetranscol:'',
			isdetail:false,
			rowkey:'rowid',
			divclass:''
		};
	},
	created() {
		if(this.item.l_tabevent!=''&&this.item.l_tabevent!=undefined)
			this.l_id=this.item.l_tabevent;
		else
			this.l_id=this.item.l_id;
	},
	mounted() {
		//import('../../static/' + this.$theme + '/style/createcwbill.scss');
		
		this.init();
	},
	methods:{
		init(){
			if (this.urlparam != undefined) {
				this.type=this.item.l_tablename;
				this.pageparam = this.urlparam;
				if (this.urlparam.pkval != undefined) {
					this.curpkval = this.urlparam.pkval;
					if (this.urlparam.iscopy != undefined) {
						this.iscopy = this.urlparam.iscopy;
					}
				}
				if(this.urlparam.isedit!=undefined)
					this.isedit=this.urlparam.isedit;	
				if(this.urlparam.isdetail!=undefined)
					this.isdetail=this.urlparam.isdetail;
			}
			this.loadlanguage();
		},
		loadlanguage(){
			var that=this;
			this.$public.GetLanguageByMode(this.type,this).then(res=>{
				//debugger
				if(res.state=='1')
					that.infolang=that.$lang.label[that.type];
				if(this.curpkval!='')//加载单据信息
					this.GetOrderInfo();
				else
					this.GetPageLayout();
			});
		},
		GetOrderInfo(){
			var that=this;
			this.$tool.loading(that.$lang.label.public.loading, this.divclass);
			var paraminfo={
				pkval:this.curpkval,
				l_id:this.l_id
			}
			this.$apipost.get.GetOrderInfoByLid({paraminfo:paraminfo}).then(res => {
				this.$tool.loadingclose();
				if (res != '') {
					that.orderinfo = res;
					that.GetPageLayout();
				} else
					this.$tool.message(that.$lang.label.public.getinfofailed, "0");
			});
		},
		GetPageLayout(){
			var that = this;
			//this.truncatepage();
			this.$tool.loading(that.$lang.label.public.loading, this.divclass);
			//判断是哪种类型的下单功能,显示对应组件
			this.$apipost.get.GetTransFormat({
				p_mode: this.type
			}).then(res => {
				this.$tool.loadingclose();
				var t_id="",pagetranscol="",syscol="";
				if (res.state == '1') {
					if (res.set != undefined) {
						if(res.set.t_id!=undefined)
						{
							t_id = res.set.t_id;
							pagetranscol=res.set.pagetranscol;
							syscol= res.set.t_syscol
						}
					}
					var list=[];
					if(t_id==''&&res.list!=undefined){
						list = res.list.filter(function(re) {
							return re.t_type == that.type;
						});
						if(list.length>0){
							t_id = list[0].t_id;
							pagetranscol=list[0].pagetranscol;
							syscol= list[0].t_syscol;
						}
					}
					if(t_id!=''){
						that.t_id=t_id;
						that.isload=true;
						that.pagetranscol=pagetranscol;
						if(that.orderinfo!='')
							that.orderinfo = that.$tool.TransOrderInfo(pagetranscol, that);
						
						that.$nextTick(function(){
							that.$refs['maininfo_'+that.l_id].init({
								pkval:that.curpkval,
								iscopy:that.iscopy,
								type:that.type,
								orderinfo:that.orderinfo,
								syscol:syscol,
								t_id: t_id,
								isdetail:that.isdetail,
							});
							that.$refs['gridlistexpand_'+that.l_id].init(
							{
							 pkval:that.curpkval,
							 iscopy:that.iscopy,
							 type:that.type,
							 orderinfo:that.orderinfo,
							 syscol:syscol,
							 t_id: t_id
							});
						});
					}
				}
			});
		
		},
		// callbackFun(e){
		// 	console.log('122');
		// 	debugger
			
		// },
		//保存
		saveorder(){
			//debugger
			var that=this;
			var orderinfo=this.$tool.getOrderinfo(this.$refs['maininfo_'+this.l_id]._data,this.curpkval,this);
			
			if(orderinfo!='')
			   orderinfo=this.$tool.getOrderinfo(this.$refs['gridlistexpand_'+this.l_id]._data,this.curpkval,this,orderinfo);
			//debugger
			if(orderinfo.list!=undefined){//处理明细数据
				//筛选有扩展行的数据
				var defaultrow={};
				for(var i=0;i<orderinfo.list.length;i++){
					if(orderinfo.list[i].expandlist.length>0){
						defaultrow=JSON.parse(JSON.stringify(orderinfo.list[i].expandlist[0]));
						break;
					}
				}
				//清空值
				for(var i in defaultrow){
					if(i.toString()!="index")
						defaultrow[i]="";
				}
				for(var i=0;i<orderinfo.list.length;i++){
					if(orderinfo.list[i].expandlist.length==0){
						var rowsinfo=JSON.parse(JSON.stringify(defaultrow));
						rowsinfo.p_box=orderinfo.list[i].rowid;
						orderinfo.list[i].expandlist.push(rowsinfo);
					}
				}
			}   
			if(orderinfo!=''){
				orderinfo.editid=this.curpkval;
				orderinfo.t_id=that.t_id;
				orderinfo.u_userid=localStorage.getItem('userid');
				this.btndisabled=true;
				this.$tool.loading(that.$lang.label.public.saving, this.divclass);
				this.$apipost.post.SaveInfo({ paraminfo: orderinfo }).then(res => {
					this.$tool.loadingclose();
					this.btndisabled=false;
					if (res.state == '1') {
						this.$tool.message(that.$lang.label.public.savesuccess, "1");
						setTimeout(function(){
							that.cancel();
						},1000);
					}
					else
						this.$tool.message(res.message, "0");
						//this.$tool.message(that.$lang.label.xunjia_lang[res.message], "0");
				});
			}
		},
		//取消保存
		cancel(){
			Utils.$emit('handleRermove', localStorage.getItem('tabname'));
		}
	}
}
</script>

<style>
</style>